module.exports = __webpack_public_path__ + "assets/images/rbyearend-04.jpg?v=c71bc03a";